import type React from 'react';

import { translationKey } from '@change-corgi/core/i18n';

import { SectionIntro } from '#src/app/pages/about/impact/shared/components';

import { VideoCarousel } from './components/VideoCarousel';
import { usePetitionStarters } from './hooks/usePetitionStarters';

export const PetitionStarters: React.FC<EmptyProps> = () => {
	const {
		data: { videoStories },
	} = usePetitionStarters();

	// no stories, no story with a video, or a failed fetch: the section is hidden and its neighbours adjoin
	if (videoStories.length === 0) {
		return null;
	}

	return (
		<section className="flex flex-col gap-10 pb-16 md:gap-14 md:pb-32">
			<div className="container">
				<SectionIntro
					eyebrow={translationKey('corgi.impact_page.petition_starters.eyebrow')}
					heading={translationKey('corgi.impact_page.petition_starters.heading')}
					body={translationKey('corgi.impact_page.petition_starters.body')}
					align="center"
				/>
			</div>
			<VideoCarousel stories={videoStories} />
		</section>
	);
};
